import { IPivotProps, Pivot, PivotItem } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

const pages = ['inbox', 'outbox', 'sent', 'draft']

export type MailboxTabsProps = Omit<
  IPivotProps,
  'selectedKey' | 'onLinkClick'
> & {
  selectedPage: string
  onSelectPage: (page: string) => void
}

export const MailboxTabs: React.FC<MailboxTabsProps> = ({
  selectedPage,
  onSelectPage,
  ...props
}) => {
  const { t } = useTranslation(['mailbox', 'common'])
  const handleLinkClicked = React.useCallback(
    (link?: PivotItem) => {
      if (link) {
        onSelectPage(link.props.itemKey!)
      }
    },
    [onSelectPage]
  )

  return (
    <Pivot
      {...props}
      headersOnly={true}
      selectedKey={selectedPage}
      onLinkClick={handleLinkClicked}
    >
      {pages.map((page) => (
        <PivotItem
          key={page}
          itemKey={page}
          headerText={t(`pages.${page}.title`)}
        />
      ))}
    </Pivot>
  )
}
